export const defaultState = {
    isRequestPending: false,
    isError: false,
    isSuccess: false,
    message: null,
    isDataLoading: false,
    notifyQueue: []
};

export const mutations = {
    setIsRequestPending(state) {
        state.isRequestPending = true;
        state.isError = false;
        state.isSuccess = false;
    },
    setRequestDone(state) {
        state.isRequestPending = false;
    },
    setIsError(state, message) {
        state.isRequestPending = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = message || 'Data request failed!';
    },
    setIsSuccess(state, message) {
        state.isRequestPending = false;
        state.isError = false;
        state.isSuccess = true;
        state.message = message || 'Data request succeeded';
    },
    resetNotification(state) {
        state.isRequestPending = false;
        state.isError = false;
        state.isSuccess = false;
    },
    setIsDataLoading(state, value) {
        state.isDataLoading = value;
    },
    setNotifyQueue(state, value) {
        state.notifyQueue = Array.isArray(value) ? value : [];
    },
    addNotification(state, { type, message, component, error }) {
        // will add new item to the notifyQueue
        state.notifyQueue.push({ type, message, component, error });
    },
    shiftNotifyQueue(state) {
        // will remove the first item from the notify queue
        state.notifyQueue.shift();
    }
};

export const actions = {
    requestPending({ commit }) {
        commit('setIsRequestPending');
    },
    requestDone({ commit }) {
        commit('setRequestDone');
    },
    error({ commit }, { message, component, error }) {
        // component: snackbar or dialog
        commit('setIsError', message);
        commit('addNotification', {
            type: 'error',
            message: message,
            component: component || 'snackbar',
            error: error
        });
    },
    success({ commit }, { message, component }) {
        // component: snackbar or dialog
        commit('setIsSuccess', message);
        commit('addNotification', {
            type: 'success',
            message: message,
            component: component || 'snackbar'
        });
    },
    reset({ commit }) {
        commit('resetNotification');
    },
    loading({ commit }, value) {
        commit('setIsDataLoading', value);
    },
    removeFirst({ commit }) {
        commit('shiftNotifyQueue');
    },
    clearQueue({ commit }) {
        commit('setNotifyQueue', []);
    }
};

const notifier = {
    namespaced: true,
    state: defaultState,
    mutations: mutations,
    actions: actions
};

export default notifier;
